import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Localization\SetLanguageController::__invoke
* @see app/Http/Controllers/Localization/SetLanguageController.php:13
* @route '/localization/language'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/localization/language',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Localization\SetLanguageController::__invoke
* @see app/Http/Controllers/Localization/SetLanguageController.php:13
* @route '/localization/language'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Localization\SetLanguageController::__invoke
* @see app/Http/Controllers/Localization/SetLanguageController.php:13
* @route '/localization/language'
*/
update.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

const language = {
    update: Object.assign(update, update),
}

export default language